module.exports = __webpack_public_path__ + "static/media/message.780988fe.svg";